import {
  FETCH_EMPLOYE_REQUEST,
  FETCH_EMPLOYE_SUCCESS,
  FETCH_EMPLOYE_FAILURE,
} from './employeTypes';

const initialState = {
  loading: false,
  employe: null,
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_EMPLOYE_SUCCESS:
      return {
        loading: false,
        employe: action.payload,
        error: '',
      };
    case FETCH_EMPLOYE_FAILURE:
      return {
        loading: false,
        employe: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
